import { useSession } from "next-auth/react";
import ProtectedRoute from "components/protected-route";
import { Page } from "components/page";
import { KanbanBoard } from "components/kanban";
import { useColorModeValue } from "@chakra-ui/react";
import { getPlan } from "controllers/subscription";
import { UpgradePopup } from "components/upgrade-popup";

export const Drafts = () => {
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";
  const bgColor = useColorModeValue('white', undefined);

  if (!(loading || session)) {
    return <ProtectedRoute />;
  }

  const plan = getPlan(session?.user);
  const isStarterPlan = plan === "start";

  return (
    <Page mainWrapperProps={{ bg: bgColor, px: 4, py: 6, maxW: 'initial', minH: '100vh' }}>
      {isStarterPlan ? (
        <UpgradePopup
          currentPlan={plan}
          feature="Drafts"
          availablePlans={["grow", "enterprise"]}
        />
      ) : (
        <KanbanBoard />
      )}
    </Page>
  );
};

export default Drafts;
